import { render, staticRenderFns } from "./UpdatingSystem.vue?vue&type=template&id=7ac2bf49&lang=html"
import script from "./UpdatingSystem.vue?vue&type=script&lang=js"
export * from "./UpdatingSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports